import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { css, style, hover, media, merge } from 'glamor';

import { FAMILY_EXTENDED } from 'depop/styles/typography';
import AppStore from 'depop/components/badges/AppStore';
import PlayStore from 'depop/components/badges/PlayStore';

import taglineMobileEnglishSrc from '../../../assets/taglines/tagline_web_mobile_en.svg';
import taglineMobileItalianSrc from '../../../assets/taglines/tagline_web_mobile_it.svg';
import taglineDesktopEnglishSrc from '../../../assets/taglines/tagline_web_desktop_en.svg';
import taglineDesktopItalianSrc from '../../../assets/taglines/tagline_web_desktop_it.svg';

import iPhoneDevice  from '../../../assets/devices/iphone@2x.png';
import androidDevice  from '../../../assets/devices/android@2x.png';

const itunesStoreLink = 'https://itunes.apple.com/gb/app/depop/id518684914?mt=8';
const playStoreLink = 'https://play.google.com/store/apps/details?id=com.depop&hl=en_GB';

const hide = {display: 'none'};
// const mediaDesktop = '@media (min-width: 701px)';
// const mediaMobile = '@media (max-width: 700px)';

// const yellow = { backgroundColor: 'yellow' };
// const purple = { backgroundColor: 'rebeccapurple' };

const mobileHidden  = { '@media (max-width: 700px)': hide };
const desktopHidden = { '@media (min-width: 701px)': hide };
const wrapperStyle = css({
  textAlign: 'center',
  marginBottom: '20px',
  '@media (min-width: 701px)': {
    display: 'flex'
  }});
const storeButtonStyle = css({display: 'inline-block', '&+&': {marginLeft: '15px'}});
const taglineMobileStyle = css({padding: '45px 20px', ...desktopHidden});
const taglineDesktopStyle = css({flexBasis: '75%'});
const leftSideDesktopStyle = css({
  ...mobileHidden,
  flexBasis: '60%',
  paddingTop: '85px',
  paddingTop: '5vw',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  '@media (max-width: 1024px)': {
    paddingTop: '65px',
    paddingTop: '6.7vw',
  }
});
const buttonMobileStyle = css({marginBottom: '60px', ...desktopHidden});
const deviceWrapStyle = css({flexBasis: '40%', padding: '0px 6%'});
const imageStyle = css({maxWidth: '100%', width: '100%'});
const promoTextStyle = css({
  padding: '30px 0',
  fontFamily: FAMILY_EXTENDED,
  fontSize: '16px',
  // fontSize: '1.25vw',
  color: '#262626',
  '@media (max-width: 1024px)': {
    fontSize: '14px',
    fontSize: '1.6vw',
  }
});

const messages = defineMessages({
  lang: {
    id: 'Language.ShortCode',
    defaultMessage: 'en'
  },
  tagline: {
    id: 'Landing.taglineText',
    defaultMessage: 'Find something that means something'
  }
});

const getTaglines = (language) => {
  switch (language) {
    case 'it':
      return {
        taglineMobileSrc: taglineMobileItalianSrc,
        taglineDesktopSrc: taglineDesktopItalianSrc
      };
    case 'en':
    default:
      return {
        taglineMobileSrc: taglineMobileEnglishSrc,
        taglineDesktopSrc: taglineDesktopEnglishSrc
      };
  }
};

class HomeHeader extends React.Component {

  render() {
    const { overlays, userAgent, intl, action } = this.props;
    const isiOS = userAgent.isiPad || userAgent.isiPhone || userAgent.isiPod;
    const isAndroid = userAgent.isAndroid;
    const isMobile = userAgent.isMobile;
    const phoneImageSrc = isAndroid ? androidDevice : iPhoneDevice;
    const storeLink = isAndroid ? playStoreLink : itunesStoreLink;
    const channel = `landingpage_${(isMobile ? 'mobile' : 'desktop')}_${(isAndroid ? 'google' : 'apple')}_b`;
    const { link } = overlays.deeplink || { link: '' };
    const href = (link) ? `${link}?channel=${channel}` : storeLink;
    const { taglineMobileSrc, taglineDesktopSrc } = getTaglines(intl.formatMessage(messages.lang));
    const onAppleClick = () => action('app store');
    const onGoogleClick = () => action('play store');

    return (
      <div>
        <div {...wrapperStyle}>
          <div {...taglineMobileStyle}>
            <img {...imageStyle} src={taglineMobileSrc} alt={intl.formatMessage(messages.tagline)} />
          </div>
          <div {...leftSideDesktopStyle}>
            <div {...taglineDesktopStyle}>
              <img {...imageStyle} src={taglineDesktopSrc} alt={intl.formatMessage(messages.tagline)} />
              <div {...promoTextStyle}>
                <FormattedMessage
                  id="Landing.promoText"
                  defaultMessage="Buy, sell, and explore the most unique and inspiring things in the world." />
              </div>
            </div>
            <div>
              <a {...storeButtonStyle} onClick={onAppleClick} rel="noopener" href={itunesStoreLink}><AppStore /></a>
              <a {...storeButtonStyle} onClick={onGoogleClick} rel="noopener" href={playStoreLink}><PlayStore /></a>
            </div>
          </div>
          <div {...buttonMobileStyle}>
            {isiOS     ? <a {...storeButtonStyle} onClick={onAppleClick} rel="noopener" href={href}><AppStore /></a> : ''}
            {isAndroid ? <a {...storeButtonStyle} onClick={onGoogleClick} rel="noopener" href={href}><PlayStore /></a> : ''}
          </div>
          <div {...deviceWrapStyle}>
            <img {...imageStyle} src={phoneImageSrc} alt="Depop app screen" />
          </div>
        </div>
      </div>
    );

  }

}

const mapStateToProps = ({ userAgent, overlays }) => ({
  userAgent,
  overlays
});

export default connect(mapStateToProps)(injectIntl(HomeHeader));



// WEBPACK FOOTER //
// ../src/client/apps/root/components/HomeHeader.js